<script lang="ts" setup>
type sortByProps = {
  sortOptions: SortOpion[] | undefined
}

const props = defineProps<sortByProps>()
const selectedOption = ref<SortOpion | undefined>()

const changeSortBy = async () => {
  if (selectedOption.value) {
    await navigateTo({
      query: { ...useRoute().query, sortBy: selectedOption.value?.value, sortOrder: selectedOption.value?.sortOrder },
    })
  }
}

watch(
  () => props.sortOptions,
  () => {
    selectedOption.value = props.sortOptions?.find((sort) => sort?.selected)
  },
)
</script>

<template>
  <div class="sort-by">
    <span variant="text" class="sort-by__button">
      <span class="sort-by__button--mobile">{{ $t('plp.filter.menu.list.title.sort') }}</span>
      <span class="sort-by__button--desktop">
        {{ `${$t('plp.filter.menu.list.title.sort')}: ${selectedOption?.label || ''}` }}
      </span>
      <svg-icon name="mhj:symbol-arrow-down" />
    </span>
    <select
      id="sort"
      v-model="selectedOption"
      class="sort-select"
      name="sort"
      data-testid="plp-sort"
      @change="changeSortBy"
    >
      <option
        v-for="item in sortOptions"
        :key="item?.label"
        :value="item"
        :data-testid="`plp-sort-option-${item?.value}-${item?.sortOrder}`"
      >
        {{ item?.label }}
      </option>
    </select>
  </div>
</template>

<style lang="postcss">
.sort-by {
  position: relative;

  .sort-by__button {
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    &:has(+ .sort-select:hover),
    &:has(+ .sort-select:focus) {
      cursor: pointer;
      color: var(--text-link-hover);
      text-decoration: underline;
    }
    .sort-by__button--mobile {
      display: inline-block;
      @media (--tablet) {
        display: none;
      }
    }
    .sort-by__button--desktop {
      display: none;
      @media (--tablet) {
        display: inline-block;
      }
    }
  }

  .sort-select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    overflow: hidden;
  }
}
</style>
